import { EAcquisitionType } from "@constants";
import { getAcquisitionType } from "@utils/acquisitionTypeUtils";

export interface IClearCartPayload {
    acquisitionType: EAcquisitionType;
}

export const getStateToPayload = (): IClearCartPayload => ({
    acquisitionType: getAcquisitionType(),
});
